import "dotenv/config";
import React from "react";
import ReactDOM from "react-dom";
import AppMain from "./app-main";
import "./index.css";

const rootElement = document.getElementById("datails");

ReactDOM.render(<AppMain />, rootElement);

window.dataLayer.push({
  event: "pageview",
});
